<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-btn color="primary" fab small dark @click="onAddNewClicked">
              <v-icon>add</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex sm6></v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="searchTable"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="desserts"
            :pagination.sync="pagination"
            :total-items="totalDesserts"
            :loading="loading"
            class="elevation-1"
            :rows-per-page-items="$CONFIG.tablePG"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.payment_date }}</td>
                <td>{{ props.item.investors___name }}</td>
                <td>{{ props.item.method }}</td>
                <td>{{ props.item.amount }}</td>
                <td>
                  <v-menu offset-y transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon small color="primary" v-on="on">
                        <v-icon dark>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in rowActionItems"
                        :key="index"
                        @click="onRowActionItemClicked(item.value, props.item)"
                      >
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template slot="no-data">
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isAddFormModal" scrollable persistent max-width="600px">
      <AddForm
        :investorsTV="investorsTV"
        @cancelled="isAddFormModal = false"
        @added="getDataFromApi"
      />
    </v-dialog>
    <v-dialog v-model="isEditFormModal" scrollable persistent max-width="600px">
      <EditForm
        :investorsTV="investorsTV"
        @cancelled="isEditFormModal = false"
        :edit-item="editItem"
        @updated="getDataFromApi"
      />
    </v-dialog>
    <v-dialog v-model="isDetailsModal" scrollable persistent max-width="600px">
      <DetailsView @cancelled="isDetailsModal = false" :item="editItem" />
    </v-dialog>
  </div>
</template>

<script>
import Nl2br from "vue-nl2br";
import AddForm from "./InvestAdd";
import EditForm from "./InvestEdit";
import DetailsView from "./InvestDetails";
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

export default {
  components: {
    Nl2br,
    AddForm,
    EditForm,
    DetailsView,
  },
  data: () => ({
    actionButtonClicked: false,

    headers: [
      { text: "Date", value: "payment_date" },
      { text: "Investor", value: "investors___name" },
      { text: "Method", value: "method" },
      { text: "Amount", value: "amount" },
      { text: "Actions", value: "name", sortable: false },
    ],

    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {
      sortBy: "payment_date",
      descending: true,
    },
    getApiaParams: {
      // fields: "id,payment_date,method,amount,check_date,check_bank_name,check_bank_branch,check_number,account_head_id,notes",
      search_fields: "payment_date,method,amount,investors___name",
    },
    searchTable: "",

    rowActionItems: [
      { title: "View Details", value: "details" },
      { title: "Edit", value: "edit" },
      { title: "Delete", value: "delete" },
    ],

    isAddFormModal: false,
    isEditFormModal: false,
    isDetailsModal: false,
    editItem: {},

    investors: [],
  }),

  computed: {
    investorsTV() {
      return getTV(this.investors, { textField: "name", valueField: "id" });
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    searchTable: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {},

  methods: {
    getDataFromApi() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      if (sortBy == null) {
        delete this.getApiaParams.sort;
      } else {
        this.getApiaParams.sort = descending ? "-" + sortBy : "+" + sortBy;
      }
      this.getApiaParams.limit = rowsPerPage;
      this.getApiaParams.offset = (page - 1) * rowsPerPage;
      this.getApiaParams.search = this.searchTable;

      this.get("/investments", this.getApiaParams).then((response) => {
        this.desserts = response.data.data.items;
        this.totalDesserts = response.data.data.total_items;
        this.loading = false;
      });
    },
    loadInvestors() {
      this.get("/investors").then((response) => {
        this.investors = response.data.data;
      });
    },
    onAddNewClicked() {
      this.isAddFormModal = true;
      this.loadInvestors();
    },
    onEditClicked(item) {
      this.editItem = item;
      this.isEditFormModal = true;
      this.loadInvestors();
    },
    onDetailsClicked(item) {
      this.editItem = item;
      this.isDetailsModal = true;
    },
    onRowActionItemClicked(action, item) {
      switch (action) {
        case "details":
          this.onDetailsClicked(item);
          break;
        case "edit":
          this.onEditClicked(item);
          break;
        case "delete":
          this.$confirm("Do you really want to DELETE investment ?").then((isConfirmed) => {
            if (isConfirmed) {
              this.$http.delete("/investment/" + item.id).then((res) => {
                if (res.data.success) {
                  this.desserts = this.desserts.filter((row) => row.id != item.id);
                }
                this.snackbarShow(res.data);
              });
            }
          });
          break;
      }
    },
  },

  beforeDestroy() {},
};
</script>
